import INC_BASE_API from 'apis/incentivio-api';
import { getResponseErrorMessage } from 'apis/incentivio-api.util';
import { useURLSearchParams } from 'hooks/useURLSearchParams';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setCustomerInfo } from 'redux/cart/cart.actions';
import { selectClientName } from 'redux/config/config.selectors';
import {
  fetchUserDataStartAsync,
  signInStartAsync,
} from 'redux/user/user.actions';
import { selectIsLoggedIn } from 'redux/user/user.selectors';

export const useVerifyUser = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const code = useURLSearchParams().get('code');
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);

  const verifyUser = async () => {
    setLoading(true);

    try {
      const response = await INC_BASE_API.post(`/verifyemail?code=${code}`);
      setData(response.data);
      if (isLoggedIn) {
        const userData = await dispatch(fetchUserDataStartAsync());
        if (userData) {
          dispatch(
            setCustomerInfo({
              firstName: userData.firstName,
              lastName: userData.lastName,
              email: userData.email,
              phoneNumber: userData.phoneNumber,
            }),
          );
        }
      }
    } catch (error) {
      toast.error(getResponseErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!code) setError(true);
  }, [code]);

  return { loading, data, error, verifyUser };
};

export const useEditAccountVerification = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useURLSearchParams().get('code');
  const clientName = useSelector(selectClientName);

  const mobileSignup = async formData => {
    try {
      const { status } = await INC_BASE_API.put(
        `/useraccounts/update-with-token/${token}`,
        {
          firstName: formData?.firstName,
          lastName: formData?.lastName,
          email: formData?.email,
          phoneNumber: formData?.phoneNumber,
          password: formData?.password,
        },
      );

      if (status === 200) {
        await dispatch(
          signInStartAsync({
            email: formData?.email,
            password: formData?.password,
            remember_me: false,
          }),
        );

        history.push('/');
        toast.success(t('signUp.successMessage', { clientName }));
      }
    } catch (error) {
      toast.error(getResponseErrorMessage(error));
    }
  };

  return { mobileSignup };
};
